import type { SVGProps } from 'react'
const MojavezFaaliyatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 224 223"
    {...props}
  >
    <g filter="url(#Mojavez_Faaliyat_svg__a)">
      <rect
        width={144}
        height={144}
        x={40}
        y={28.699}
        fill="#fff"
        rx={36.348}
      />
      <path
        fill="#C8D3F7"
        d="M114.293 141.442c-12.484-2.153-18.726-3.23-21.936-7.778-3.21-4.547-2.132-10.789.021-23.274l3.055-17.707c2.153-12.485 3.23-18.728 7.778-21.937 4.547-3.21 10.79-2.133 23.274.021s18.727 3.23 21.936 7.778c3.21 4.547 2.133 10.79-.021 23.275l-3.054 17.707c-2.154 12.485-3.231 18.727-7.778 21.936-4.548 3.21-10.79 2.133-23.275-.021"
      />
      <g clipPath="url(#Mojavez_Faaliyat_svg__b)">
        <path
          fill="#2852E4"
          d="M112.285 133.903c-12.42 2.501-18.63 3.752-23.265.67s-5.886-9.291-8.386-21.711l-3.547-17.615c-2.5-12.42-3.751-18.63-.67-23.265s9.292-5.886 21.711-8.387c12.42-2.5 18.63-3.75 23.265-.67 4.635 3.082 5.886 9.292 8.386 21.712l3.547 17.615c2.501 12.42 3.751 18.63.67 23.265s-9.292 5.886-21.711 8.386"
        />
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={3.75}
          d="m86.798 83.819 29.41-5.922M89.199 95.819l29.409-5.922M105.999 104.858l14.705-2.961M94.257 121.527l3.765 2.174a.937.937 0 0 0 1.29-.358l4.89-8.848"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Mojavez_Faaliyat_svg__b">
        <path
          fill="#fff"
          d="m69.06 66.422 56.981-11.473 15.174 75.362-56.981 11.473z"
        />
      </clipPath>
      <filter
        id="Mojavez_Faaliyat_svg__a"
        width={222.034}
        height={222.034}
        x={0.983}
        y={0.932}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={11.25} />
        <feGaussianBlur stdDeviation={19.508} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_7373" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1_7373"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default MojavezFaaliyatIcon
